
import { useSelector } from "react-redux"
import { selectTranslations } from "../../services/i18n/i18nSlice"
import { Link } from "react-router-dom"
import { useTour } from '@reactour/tour'
import { examsTourSteps, homeTourSteps, personalizationTourSteps, trainingsTourSteps, usersTourSteps } from "../../config/tour"
import icon_home from '../../assets/images/home.svg'

import "react-step-progress-bar/styles.css";
import { ProgressBar, Step } from "react-step-progress-bar";

import users_img from '../../components/Navigation/icons/users.svg'
import formazione_img from '../../components/Navigation/icons/formazione.svg'
import notifiche_img from '../../components/Navigation/icons/notifiche.svg'
import verifica_img from '../../components/Navigation/icons/verifica.svg'
import personalizations_img from '../../components/Navigation/icons/personalizations.svg'
import stats_img from '../../components/Navigation/icons/stats.svg'
import social_img from '../../assets/images/social.svg'
import thunder_img from '../../assets/images/thunder.svg'
import copy_img from '../../assets/images/copy_white.svg'

import arrow_right from '../../assets/images/arrow-right.svg'

import './HomeScreen.css'
import { selectUserData, selectUserOnboarding } from "../../features/User/userSlice"
import { useEffect } from "react"
import { BASE_URL } from "../../config/constants"
import { toast } from "react-toastify"

const SECTIONS_INFO = {
  users : {
    details: "Gestisci utenti, gruppi, admin e permessi",
    icon: users_img,
    link: "/users"
  },
  trainings: {
    details: "Gestisci cartelle, materiali ed allenamenti",
    icon: formazione_img,
    link: "/folders"
  },
  exams: {
    details: "Gestisci prove di verifica e questionari",
    icon: verifica_img,
    link: "/exams"
  },
  personalizations: {
    details: "Gestisci le personlizzazione dell'applicativo",
    icon: personalizations_img,
    link: "/settings"
  },
  reports: {
    details: "Visualizza report, dati e statistiche",
    icon: stats_img,
    link: "/analytics"
  },
}

export default function HomeScreen() {

    const t = useSelector(selectTranslations)

    const userData = useSelector(selectUserData)
    const userOnboarding  = useSelector(selectUserOnboarding)

    const handleCopyURL = () => {
      if(navigator.clipboard.writeText(BASE_URL))
        toast.success(t.home.copied_link)
    }

    const { setIsOpen, setCurrentStep, setSteps, setMeta } = useTour()
    
    useEffect(()=>{
      setIsOpen(false)
      if(!userOnboarding?.general?.section_completed && !userData?.is_super_admin ){
        setTimeout(()=>setIsOpen(true),1500)
        setSteps(homeTourSteps)
        setCurrentStep(userOnboarding?.general?.step_completed_count)
        setMeta('general')
      }
      
    },[])

    return(
        <div className="p-2">
            <div className="d-flex justify-content-between">
                <div className="page_title">
                    <img src={icon_home} alt=''/>
                    <h1>{t.home.page_title}</h1>
                </div>
            </div>
            <div className="row my-3 align-items-strech">
              {
                userOnboarding &&
                  <div className="col-9 px-3">
                    <div className="home_link__card h-100">
                      <h3 className="mt-0"><img src={thunder_img} /> {t.home.intro}</h3>
                      <p className="mt-4 mb-1">{t.home.your_progress}:</p>
                      <div className="d-flex align-items-center">
                        <ProgressBar
                          percent={parseInt(Object?.values(userOnboarding)?.filter(item => item?.section_completed === true)?.length*100/5) }
                          height='20px'
                          width="90%"
                          stepPositions={[0,20,40,60,80,98]}
                          filledBackground="linear-gradient(to right, #1299B6, #00C5AD)"
                        >
                          <Step transition="scale" position={0}>
                            {({ accomplished }) => (
                              <></>
                            )}
                          </Step>
                          <Step transition="scale" position={20}>
                            {({ accomplished }) => (
                              <div className="d-block" style={{position:'relative'}}>
                                  <div style={{ display:'block', height:'10px', width:'10px', background:`${accomplished ? '#F4F4F4' : '#F4F4F4'}`, borderRadius:'50%' }} width='10' className='mx-auto'/>
                                  <img
                                    width="20"
                                    src={formazione_img}
                                    style={{position:"absolute", top:'20px', left:'-5px', filter: `grayscale(${accomplished ? 0 : 80}%)`}}
                                  />
                              </div>
                            )}
                          </Step>
                          <Step transition="scale" position={40}>
                            {({ accomplished }) => (
                              <div className="d-block" style={{position:'relative'}}>
                                  <div style={{ display:'block', height:'10px', width:'10px', background:`${accomplished ? '#F4F4F4' : '#F4F4F4'}`, borderRadius:'50%' }} width='10' className='mx-auto'/>
                                  <img
                                    width="20"
                                    src={verifica_img}
                                    style={{position:"absolute", top:'20px', left:'-5px', filter: `grayscale(${accomplished ? 0 : 80}%)`}}
                                  />
                              </div>
                            )}
                          </Step>
                          <Step transition="scale" position={60}>
                            {({ accomplished }) => (
                              <div className="d-block" style={{position:'relative'}}>
                                  <div style={{ display:'block', height:'10px', width:'10px', background:`${accomplished ? '#F4F4F4' : '#F4F4F4'}`, borderRadius:'50%' }} width='10' className='mx-auto'/>
                                  <img
                                    width="20"
                                    src={users_img}
                                    style={{position:"absolute", top:'20px', left:'-5px', filter: `grayscale(${accomplished ? 0 : 80}%)`}}
                                  />
                              </div>
                            )}
                          </Step>
                          <Step transition="scale" position={80}>
                            {({ accomplished }) => (
                              <div className="d-block" style={{position:'relative'}}>
                                  <div style={{ display:'block', height:'10px', width:'10px', background:`${accomplished ? '#F4F4F4' : '#F4F4F4'}`, borderRadius:'50%' }} width='10' className='mx-auto'/>
                                  <img
                                    width="20"
                                    src={personalizations_img}
                                    style={{position:"absolute", top:'20px', left:'-5px', filter: `grayscale(${accomplished ? 0 : 80}%)`}}
                                  />
                              </div>
                            )}
                          </Step>
                          <Step transition="scale" position={98}>
                            {({ accomplished }) => (
                              <div className="d-block" style={{position:'relative'}}>
                                  <div style={{ display:'block', height:'10px', width:'10px', background:`${accomplished ? '#F4F4F4' : '#F4F4F4'}`, borderRadius:'50%' }} width='10' className='mx-auto'/>
                                  <img
                                    width="20"
                                    src={stats_img}
                                    style={{position:"absolute", top:'20px', left:'-5px', filter: `grayscale(${accomplished ? 0 : 80}%)`}}
                                  />
                              </div>
                            )}
                          </Step>
                        </ProgressBar>
                        <p className="ms-4 mb-0">
                          {parseInt(Object.values(userOnboarding).filter(item => item.section_completed === true)?.length*100/5)}%
                        </p>
                      </div>
                    </div>
                  </div>
              }
              <div className="col-3 px-3">
                <div className="home_link__card">
                  <img src={social_img} className="mx-auto d-block"/>
                  <p className="my-0 text-tf fw-bold text-center">{t.home.user_link}</p>
                  <p className="text-center">{t.home.user_text}</p>
                  <button className="mx-auto d-block" onClick={handleCopyURL}>{t.home.copy_link} <img src={copy_img} /></button>
                </div>
              </div>
            </div>
            {
              (userOnboarding && Object.values(userOnboarding).filter(item => item.section_completed === false)?.length > 1) &&
              <>
              <h3 className="mt-4">{t.home.discover_panel}:</h3>
              <div className="home_link__card h-100 pt-4">
                {
                  /*General Tour*/
                  userOnboarding?.general?.step_completed_count < homeTourSteps.length-1 &&
                    <div className="row mb-5 align-items-center">
                      <div className="col-9">
                        <h3 className="mt-0"><img src={icon_home} style={{maxWidth:'24px'}} /> {t.home.tour_sections.general}</h3>
                        <p>{t.home.tour_sections.general_text}</p>
                      </div>
                      <div className="col-3">
                        <div className="d-flex align-items-center">
                          <ProgressBar
                            percent={parseInt(userOnboarding?.general?.step_completed_count*100/(homeTourSteps.length-1)) }
                            height='20px'
                            width="90%"
                            filledBackground="linear-gradient(to right, #1299B6, #00C5AD)"
                          />
                          <p className="ms-4 mb-0">
                            {parseInt(userOnboarding?.general?.step_completed_count*100/(homeTourSteps.length-1))}%
                          </p>
                        </div>
                      </div>
                  </div>
                }
                {
                  /*Folder Tour*/
                  userOnboarding?.trainings?.step_completed_count < trainingsTourSteps()?.length-1 &&
                    <div className="row mb-5 align-items-center">
                      <div className="col-9">
                        <h3 className="mt-0"><img src={formazione_img} style={{maxWidth:'24px'}} /> {t.home.tour_sections.trainings}</h3>
                        <p>{t.home.tour_sections.trainings_text}</p>
                        <Link to={"/folders"}>
                          <button>
                            {t.home.go_to_section} <img src={arrow_right} />
                          </button>
                        </Link>
                      </div>
                      <div className="col-3">
                        <div className="d-flex align-items-center">
                          <ProgressBar
                            percent={parseInt(userOnboarding?.trainings?.step_completed_count*100/(trainingsTourSteps()?.length-1)) }
                            height='20px'
                            width="90%"
                            filledBackground="linear-gradient(to right, #1299B6, #00C5AD)"
                          />
                          <p className="ms-4 mb-0">
                            {parseInt(userOnboarding?.trainings?.step_completed_count*100/(trainingsTourSteps()?.length-1))}%
                          </p>
                        </div>
                      </div>
                  </div>
                }
                {
                  /*Exams Tour*/
                  userOnboarding?.exams?.step_completed_count < examsTourSteps().length-1 &&
                    <div className="row mb-5 align-items-center">
                      <div className="col-9">
                        <h3 className="mt-0"><img src={verifica_img} style={{maxWidth:'24px'}} /> {t.home.tour_sections.exams}</h3>
                        <p>{t.home.tour_sections.exams_text}</p>
                        <Link to={"/exams"}>
                          <button>
                            {t.home.go_to_section} <img src={arrow_right} />
                          </button>
                        </Link>
                      </div>
                      <div className="col-3">
                        <div className="d-flex align-items-center">
                          <ProgressBar
                            percent={parseInt(userOnboarding?.exams?.step_completed_count*100/(examsTourSteps().length-1)) }
                            height='20px'
                            width="90%"
                            filledBackground="linear-gradient(to right, #1299B6, #00C5AD)"
                          />
                          <p className="ms-4 mb-0">
                            {parseInt(userOnboarding?.exams?.step_completed_count*100/(examsTourSteps().length-1))}%
                          </p>
                        </div>
                      </div>
                  </div>
                }
                {
                  /*Users Tour*/
                  userOnboarding?.users?.step_completed_count < usersTourSteps().length-1 &&
                    <div className="row mb-5 align-items-center">
                      <div className="col-9">
                        <h3 className="mt-0"><img src={users_img} style={{maxWidth:'24px'}} /> {t.home.tour_sections.users}</h3>
                        <p>{t.home.tour_sections.users_text}</p>
                        <Link to={"/users"}>
                          <button>
                            {t.home.go_to_section} <img src={arrow_right} />
                          </button>
                        </Link>
                      </div>
                      <div className="col-3">
                        <div className="d-flex align-items-center">
                          <ProgressBar
                            percent={parseInt(userOnboarding?.users?.step_completed_count*100/(usersTourSteps().length-1)) }
                            height='20px'
                            width="90%"
                            filledBackground="linear-gradient(to right, #1299B6, #00C5AD)"
                          />
                          <p className="ms-4 mb-0">
                            {parseInt(userOnboarding?.users?.step_completed_count*100/(usersTourSteps().length-1))}%
                          </p>
                        </div>
                      </div>
                  </div>
                }
                {
                  /*Personalizations Tour*/
                  userOnboarding?.personalizations?.step_completed_count < personalizationTourSteps().length-1 &&
                    <div className="row mb-5 align-items-center">
                      <div className="col-9">
                        <h3 className="mt-0"><img src={personalizations_img} style={{maxWidth:'24px'}} /> {t.home.tour_sections.personalizations}</h3>
                        <p>{t.home.tour_sections.personalizations_text}</p>
                        <Link to={"/settings"}>
                          <button>
                            {t.home.go_to_section} <img src={arrow_right} />
                          </button>
                        </Link>
                      </div>
                      <div className="col-3">
                        <div className="d-flex align-items-center">
                          <ProgressBar
                            percent={parseInt(userOnboarding?.personalizations?.step_completed_count*100/(personalizationTourSteps().length-1)) }
                            height='20px'
                            width="90%"
                            filledBackground="linear-gradient(to right, #1299B6, #00C5AD)"
                          />
                          <p className="ms-4 mb-0">
                            {parseInt(userOnboarding?.personalizations?.step_completed_count*100/(personalizationTourSteps().length-1))}%
                          </p>
                        </div>
                      </div>
                  </div>
                }
              </div>
              </>
            }
            <h3 className="mt-5">{t.home.create_your_content}:</h3>
            <div className="home_links mt-3">
                {
                    Object.entries(userData?.permissions).map(([key, value]) => {
                        if(value.level > 0 && SECTIONS_INFO[key])
                            return (
                                <div className="home_link__card" key={key}>
                                    <h3><img src={SECTIONS_INFO[key].icon} style={{maxWidth:'24px'}} alt=''/> {t.home.permissions[key]}</h3>
                                    <p>{SECTIONS_INFO[key].details}</p>
                                    <Link to={SECTIONS_INFO[key].link}>
                                        <button className="secondary">{t.home.go_to_section} </button>
                                    </Link>
                                </div>
                            )
                        else 
                            return null
                    })
                }
                {
                    userData?.permissions?.users && userData?.permissions?.users?.level > 0 ?
                        <div className="home_link__card">
                            <h3><img src={SECTIONS_INFO['reports'].icon} style={{maxWidth:'24px'}} alt=''/> {t.home.permissions['reports']}</h3>
                            <p>{SECTIONS_INFO['reports'].details}</p>
                            <Link to={'/analytics'}>
                                <button className="secondary">{t.home.go_to_section} </button>
                            </Link>
                        </div>
                    : ""
                }
            </div>
              
          </div>
    )
}